import { CreateMxmCustomerMutationVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  mutationVariables: CreateMxmCustomerMutationVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class CreateMxmCustomerRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PAYMENT_METHODS,
      type: `CREATE_MXM_CUSTOMER.REQUEST`,
      data: {
        mutationVariables,
      },
    });
  }
}

export { CreateMxmCustomerRequest };
